import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from "../ActionButtons";
// import AskCancelModal from "../AskCancelModal";

// import { standardWeight_Damper } from "../../../lib/data/standard-weight";

const ChuteLinerForm = ({ onSaveStructure, onChangeWeightSummary, chuteLiners, beltWidth }) => {
    const [isShow, setIsShow] = useState(chuteLiners?.length || false);
    const [newChuteLiner, setNewChuteLiner] = useState(chuteLiners || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [typeCategory, setTypeCategory] = useState('');
    const [materialCategory, setMaterialCategory] = useState('');
    const [thickness, setThickness] = useState();
    // const [area, setArea] = useState();
    // const [standardWeight, setStandardWeight] = useState('');
    const [area, setArea] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalArea, setTotalArea] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* Category 설명하는 text */
    const typeCategoryText = useRef({
        0: 'Head Impact Part',
        1: 'Head Sliding Part',
        2: 'Connecting Impact Part',
        3: 'Connecting Sliding Part',
        4: 'Etc',
    });

    const materialCategoryText = useRef({
        0: 'Mild Steel',
        1: 'Stainless Steel',
        2: 'AR Plate',
        3: 'Ceramic',
        4: 'High Molecular Plastic',
    });

    const density = useRef({
        0: 7.85,
        1: 7.85,
        2: 7.85,
        3: 3.5,
        4: 1.5,
    });

    /*  처음 props로 넘어온 chuteLiners를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialchuteLiner = useRef(chuteLiners || []);

    /* 벨트폭에 해당하는 Weight를 가져온다. */
    // useEffect(() => {
    //     if (!standardWeight_Damper || !beltWidth) {
    //         return;
    //     }

    //     const library = standardWeight_Damper.find(item => item.beltWidth === parseInt(beltWidth));
    //     if (!library) {
    //         alert ('Check Belt Width!');
    //         return;
    //     }

    //     const index = parseInt(typeCategory);

    //     setStandardWeight(library.standardWeight[index]);
    // }, [beltWidth, typeCategory]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        if (!thickness) {
            return;
        }

        // const _unitWeight = thickness * 1000 * 1000 * 7.85 / 1000000;
        const _unitWeight = factor * (thickness * 1000 * 1000 * density.current[materialCategory]) / 1000000;
        setUnitWeight(Math.ceil(_unitWeight * 10) / 10);
    }, [thickness, materialCategory, typeCategory, factor]);

    /* 중량 계산 */
    useEffect(() => {
        if (!unitWeight || !area) {
            return;
        }

        const _weight = Math.ceil(unitWeight * area);
        setWeight(_weight);
    }, [area, unitWeight]);

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newChuteLiner.length) {
            return 0;
        }
        return Math.max(...newChuteLiner.map((item) => Number(item.id.substring(4))), 0);
    }, [newChuteLiner]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`CHL-${getLastId() * 1 + 1}`);
        // setLength('');
        // setStandardWeight('');
        // setFactor('');
        setArea('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalArea = useCallback((items) => {
        const _totalArea = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.area);
        }, 0);
        setTotalArea(_totalArea);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newChuteLiner에 chute 추가 */
    const onAddChuteLiner = useCallback(() => {
        // if (!weight) {
        //     alert('입력값을 확인하세요.');
        //     return;
        // };
        if (!unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const chuteLiner = {
            id,
            linerType: typeCategoryText.current[typeCategory],
            materialType: materialCategoryText.current[materialCategory],
            thickness,
            area,
            factor,
            unitWeight,
            weight,
        };
        setNewChuteLiner((prev) => [...prev, chuteLiner]);
        setIsChanged(true);
    }, [id, typeCategory, materialCategory, thickness, factor, area, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 chute 삭제 */
    const onDeleteChuteLiner = useCallback((id) => {
        setNewChuteLiner((prev) => prev.filter((item) => item.id !== id));
        setIsChanged(true);
    }, []);

    /* newChuteLiner에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalArea(newChuteLiner);
        getTotalWeight(newChuteLiner);
        initializeForm();
        onSaveStructure({
            key: 'chuteLiner',
            value: newChuteLiner,
        });
        onChangeWeightSummary({
            key: 'chuteLiner',
            value: {
                totalArea,
                totalWeight,
            },
        });
    }, [
        getTotalArea,
        getTotalWeight,
        initializeForm,
        newChuteLiner,
        onChangeWeightSummary,
        onSaveStructure,
        totalArea,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveChuteLiner = useCallback(() => {
    //     onSaveStructure({
    //         key: 'chuteLiner',
    //         value: newChuteLiner,
    //     });
    //     onChangeWeightSummary({
    //         key: 'chuteLiner',
    //         value: {
    //             totalArea,
    //             totalWeight,
    //         },
    //     });
    // }, [newChuteLiner, onChangeWeightSummary, onSaveStructure, totalArea, totalWeight]);

    /* 변경 사항을 취소하면 newChuteLiner를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewChuteLiner(initialchuteLiner.current);
    //     onSaveStructure({
    //         key: 'chuteLiner',
    //         value: initialchuteLiner.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'chuteLiner',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert ('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <ChuteLinerFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Chute(Liner)</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalArea} m2</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>Type</th>
                                <th>Material</th>
                                <th>
                                    Thickness
                                    <br />
                                    (mm)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit
                                    <br />
                                    Weight
                                    <br />
                                    (kg/m2)
                                </th>
                                <th>Area(m2)</th>
                                <th>Weight(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newChuteLiner &&
                                newChuteLiner.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.id}</td>
                                        <td>{item.linerType}</td>
                                        <td>{item.materialType}</td>
                                        <td>{item.thickness}</td>
                                        <td>{item.factor}</td>
                                        <td>{item.unitWeight}</td>
                                        <td>{item.area}</td>
                                        <td>{item.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteChuteLiner(item.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="0"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Head Impact Part</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="1"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Head Slide Part</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="2"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Connecting Impact Part</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="3"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Connecting Slide Part</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="4"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Etc.</span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="materialCategory"
                                                value="0"
                                                onChange={(e) => setMaterialCategory(e.target.value)}
                                            />
                                            <span>Mild Steel</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="materialCategory"
                                                value="1"
                                                onChange={(e) => setMaterialCategory(e.target.value)}
                                            />
                                            <span>Stainless Steel</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="materialCategory"
                                                value="2"
                                                onChange={(e) => setMaterialCategory(e.target.value)}
                                            />
                                            <span>AR Plate</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="materialCategory"
                                                value="3"
                                                onChange={(e) => setMaterialCategory(e.target.value)}
                                            />
                                            <span>Ceramic</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="materialCategory"
                                                value="4"
                                                onChange={(e) => setMaterialCategory(e.target.value)}
                                            />
                                            <span>High Molecular Plastic</span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={thickness}
                                        onChange={(e) => setThickness(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={area}
                                        onChange={(e) => setArea(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddChuteLiner}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>Chute(Liner) Total</td>
                                <td></td>
                                <td>{totalArea}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveChuteLiner} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </ChuteLinerFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const ChuteLinerFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .td-radio {
        display: flex;
        justify-content: center;
        margin: 0 auto;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.5rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default ChuteLinerForm;
